<div class="container mx-auto">
    <div class="row">
      <a href="https://www.ceeyu.us">Home</a>
    </div>
    <div>
    <form #f="ngForm"  class="ceeyu-form" [formGroup]="neweventform" class="my-form"
      (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col">
          Welcome {{visitorName}}, please enter your event details:  
        </div>
        @if (founderror) {
          <div class="col">
            {{errormessage}}
          </div>
        }
        </div>  
        <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label>Event Date</mat-label>
            <mat-date-range-input [rangePicker]="picker" [min] = min
              [max] = "_dateAdapter.addCalendarDays(neweventform.controls.fromdate.value, 7)">
              <input matStartDate  placeholder="From Date" required formControlName="fromdate">
              <input matEndDate  placeholder="To Date" required formControlName="todate">
            </mat-date-range-input>

            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>

            <!-- Invalid Date Messages -->
            @if (neweventform.controls.fromdate.hasError('matStartDateInvalid')) {
              <mat-error>Invalid start date</mat-error>
            }
            @if (neweventform.controls.todate.hasError('matEndDateInvalid')) {
              <mat-error>Invalid end date</mat-error>
            }

            <!-- Required Date Messages -->
            @if (neweventform.controls.fromdate.errors?.required) {
              <mat-error>From Date Required</mat-error>
            }
            @if (neweventform.controls.todate.errors?.required) {
              <mat-error>To Date Required</mat-error>
            }

          </mat-form-field>
          </div>  
          <!--
          <p>Selected Date Range: {{neweventform.value | json}}</p>
          -->
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-label>Event Title</mat-label>
            <input matInput  formControlName ="formControltitle" required>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-label>Event Sponsor</mat-label>
            <input matInput  formControlName ="formControlspname" required readonly>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-label>Sponsor Phone</mat-label>
            <input matInput type="tel" mask="(000) 000-0000" formControlName ="formControlspphone" required readonly>
          </mat-form-field>
        </div>
        <div class="row">
          <mat-form-field appearance="fill">
            <mat-label>Sponsor Email</mat-label>
            <input matInput  formControlName ="formControlspemail" required readonly>
          </mat-form-field>
        </div>
        <div class="row">
          <button  class="col-3 btn btn-secondary" type="reset" type="button">Reset</button>
          <div class="col-6"></div>
          <button  (click)= onSubmit() class="col-3 btn btn-primary" type="button">Submit</button>
        </div>
      </form>
    </div>
</div>
<ng-template #successfullyCreated>
  <div class="container">
  <h2 mat-dialog-title>Success</h2>
  <mat-dialog-content>
    <p>Successfully created event. Please add invites next.</p>
    </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
  </mat-dialog-actions>
  </div>
</ng-template>